
import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  text,
  className 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  return (
    <div className={cn('flex flex-col items-center justify-center gap-4', className)}>
      {/* VoiceThera Logo with breathing animation */}
      <div className="relative">
        <img
          src="/lovable-uploads/voicethera-logo-new.png"
          alt="VoiceThera"
          className="h-16 w-16 object-contain animate-pulse opacity-80"
        />
      </div>
      
      <div className="flex items-center gap-2">
        <div className="relative">
          <Loader2 className={cn('animate-spin text-primary', sizeClasses[size])} />
          <div className="absolute inset-0 rounded-full border border-primary/20 animate-ping" />
        </div>
        {text && (
          <span className="text-sm text-muted-foreground animate-pulse">{text}</span>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
